import { Link } from "react-router-dom";
import styles from "./Hero.module.css";
import { about } from "../../data/about";
import { companies } from "../../data/companies";

export default function Hero() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        {/* ── Left: content ─────────────────────────────── */}
        <div className={styles.content}>
          <span className={styles.badge}>EIE Excellence in Education</span>

          <h1 className={styles.headline}>
            Building brighter school schemata
            <br />
            that supports one{" "}
            <span className={styles.gradientText}>mind at a time.</span>
          </h1>

          <p className={styles.subtext}>
            Dr. Yasser Dawa leads EIE in transforming education across Egypt and
            the region, delivering accreditation support, school improvement,
            and digital learning solutions for more than 80 schools.
          </p>

          <div className={styles.actions}>
            <a href="#companies" className={styles.primaryBtn}>
              View partners
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
            <Link to="/eie" className={styles.secondaryBtn}>
              Learn about EIE
            </Link>
          </div>

          <div className={styles.stats}>
            <div className={styles.stat}>
              <span className={styles.statNumber}>{companies.length}</span>
              <span className={styles.statLabel}>Partners</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statNumber}>
                {Array.from(new Set(companies.map((c) => c.industry))).length}
              </span>
              <span className={styles.statLabel}>Sectors</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statNumber}>30+</span>
              <span className={styles.statLabel}>Years of Leadership</span>
            </div>
          </div>
        </div>

        {/* ── Right: photo ──────────────────────────────── */}
        <div className={styles.imageWrap}>
          <div className={styles.imageGlow} />
          <img
            src="/Uncle Yasser.jpeg"
            alt={about.name}
            className={styles.photo}
          />
        </div>
      </div>
    </section>
  );
}
